import { jsx as c } from "react/jsx-runtime";
import { useMemo as w, useState as F, useEffect as V } from "react";
import { LinkIcon as _ } from "../../icons/link-icon.mjs";
import { twMerge as h } from "tailwind-merge";
import { FormInput as I } from "./form-input.mjs";
import { useTranslation as N } from "../../i18n.mjs";
import { FormSelectInline as k } from "../form-select/form-select-inline.mjs";
import { copyTextToClipboard as z } from "../../utils/copy-to-clipboard.mjs";
const A = (t) => [
  { id: "https://", caption: "https://", customCaption: t("public_pages_purchase.input.url.site") },
  { id: "mailto:", caption: "mailto:", customCaption: t("public_pages_purchase.input.url.mail") },
  { id: "tel:", caption: "tel:", customCaption: t("public_pages_purchase.input.url.tel") }
], T = (t) => {
  var e;
  return ((e = t[0]) == null ? void 0 : e.id) ?? "https://";
}, l = (t, e) => {
  var o;
  return (o = e.find((m) => t.startsWith(m.id))) == null ? void 0 : o.id;
}, g = (t, e) => l(t, e) ?? T(e), p = (t, e) => {
  if (!t) return t;
  const o = l(t, e);
  return o && t.startsWith(o) ? t.slice(o.length) : t;
}, O = ({
  onChange: t,
  value: e = "",
  withCopyButton: o,
  buttonClassName: m,
  linkIconClassName: b,
  schemeOptions: f,
  ...S
}) => {
  const { t: a } = N(), i = w(
    () => f ?? A(a).slice(0, 1),
    [f, a]
  ), [s, u] = F(g(e, i));
  V(() => {
    if (!e) return;
    const r = g(e, i);
    r !== s && u(r);
  }, [s, i, e]);
  const x = p(e, i), y = ({ target: { value: r } }) => {
    if (!r) return t("");
    const n = l(r, i);
    if (n) {
      n !== s && u(n);
      const d = p(r, i);
      if (!d) return t("");
      t(n + d);
    } else
      t(s + p(r, i));
  }, C = (r) => {
    if (!r || (u(r), !e)) return;
    const n = p(e, i);
    if (!n) return t("");
    t(r + n);
  };
  return /* @__PURE__ */ c(
    I,
    {
      type: "url",
      addonBefore: i.length > 1 ? /* @__PURE__ */ c(
        k,
        {
          withoutCloseIcon: !0,
          data: i,
          value: s,
          optionsClassName: "min-w-0",
          captionClassName: "no-underline w-max",
          onChange: C
        }
      ) : i[0].caption,
      value: x,
      onChange: y,
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: o && /* @__PURE__ */ c(
        "button",
        {
          type: "button",
          onClick: async (r) => {
            r.preventDefault(), await z(e, a);
          },
          className: h(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            m
          ),
          children: /* @__PURE__ */ c(
            _,
            {
              className: h(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                b
              )
            }
          )
        }
      ),
      ...S
    }
  );
};
export {
  O as FormInputUrl,
  A as getUrlSchemeOptions
};
